import React from 'react'
import { Glyphicon } from 'react-bootstrap'
import moment from 'moment'
import './styles.css'

type Props = {
  _id: String,
  email: String,
  name: String,
  tags: [String],
  carrierMappings: [{ carrier: String, zip: String }],
  lastActive: String,
  setActiveVendor: Function,
  onDisplayHistory: Function,
  setSelectedVendorCarrierMapping: Function,
  setSelectedVendorToMerge: Function,
}

const VendorRow = ({ email, name, tags, carrierMappings, lastActive, setActiveVendor, onDisplayHistory, setSelectedVendorCarrierMapping, setSelectedVendorToMerge }: Props) => (
  <tr>
    <td>
      <div style={{ width: '100%', display: 'flex' }}>
        <div className="smallBtn" onClick={setActiveVendor}>
          Detaljer <Glyphicon glyph="glyphicon glyphicon-list"></Glyphicon>
        </div>
        <div className="smallBtn" onClick={setSelectedVendorCarrierMapping}>
          Mappa transportörer <Glyphicon glyph="glyphicon glyphicon-sunglasses"></Glyphicon>
          <div>{` (${(carrierMappings || []).length} st)`}</div>
        </div>
        <div className="smallBtn" onClick={setSelectedVendorToMerge}>
          Sammanfoga leverantörer
        </div>
        <div className="smallBtn" onClick={onDisplayHistory}>
          Historik <Glyphicon glyph="glyphicon glyphicon-time"></Glyphicon>
        </div>
      </div>
    </td>
    <td>{name}</td>
    <td>{email}</td>
    <td>{tags && tags.map((t) => `${t}; `)}</td>
    <td>
      {lastActive
        ? moment(lastActive)
            .locale('sv')
            .format('llll')
        : ''}
    </td>
  </tr>
)

export default React.memo(VendorRow)
